import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { Link, useLocation } from "react-router-dom";

import "./style.css";
import logo from "../../../assets/dental-inden/images/dentalID-Logo.svg";
import collapsedlogo from "../../../assets/dental-inden/images/dentalID-collapsed.svg";
import collapsedOpen from "../../../assets/dental-inden/icons/collapsedOpen.svg";
import collapsedClose from "../../../assets/dental-inden/icons/collapsedClose.svg";
import projectIcon from "../../../assets/dental-inden/icons/projects.svg";
import dashboardIcon from "../../../assets/dental-inden/icons/dashboard.svg";
import servicesIcon from "../../../assets/dental-inden/icons/servicesIcon.svg";
import logoutIcon from "../../../assets/dental-inden/icons/logoutIcon.svg";
import profileIcon from "../../../assets/dental-inden/icons/profileIcon.svg";
import aboutUsIcon from "../../../assets/dental-inden/icons/aboutUsIcon.svg";
import settingsIcon from "../../../assets/dental-inden/icons/settingsIcon.svg";
import supportIcon from "../../../assets/dental-inden/icons/supportIcon.svg";

import { useDispatch, useSelector } from "react-redux";
import { _toggleSideMenu } from "../../../redux/actions/profileSettingsAction";
import { _authenticateUser } from "../../../redux/actions/authAction";

const { Sider } = Layout;

const Sidebar = () => {
  const dispatch = useDispatch();
  const location = useLocation(); // Get the current location (URL)
  const collapsed = useSelector(
    (state) => state.settings_data?.isToggleSideMenu
  );
  // const privileges = useSelector((state) => state.auth?.privileges);
  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );
  const isDentalRecordScreen = useSelector(
    (state) => state.general.isDentalRecordScreen || false
  );
  const toggleCollapse = () => {
    dispatch(_toggleSideMenu(!collapsed));
  };

  const iconList = [
    {
      name: "services",
      src: servicesIcon,
      label: "Modules",
      path: "/",
    },
    {
      name: "dashboard",
      src: dashboardIcon,
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "projects",
      src: projectIcon,
      label: "Projects",
      path: "/projects",
    },
    {
      name: "profile",
      src: profileIcon,
      label: "Profile",
      path: "/profile",
    },

    {
      name: "aboutUs",
      src: aboutUsIcon,
      label: "About Us",
      path: "/about-us",
    },
    {
      name: "support",
      src: supportIcon,
      label: "Support",
      path: "/support",
    },
    {
      name: "settings",
      src: settingsIcon,
      label: "Settings",
      path: "/settings",
    },

    // Add more icons dynamically here
  ];

  // Map over the icon list to generate the menu items dynamically
  const menuItems = iconList.map((icon) => ({
    key: `/dental-identification${icon.path}`,
    label: (
      <Link
        to={
          icon.name === "services" ? "/" : `/dental-identification${icon.path}`
        }
      >
        {icon.label}
      </Link>
    ),
    icon: <img src={icon.src} alt={icon.name} />,
  }));

  const handleLogout = () => {
    localStorage.removeItem("user");
    dispatch(_authenticateUser(false));
  };

  return (
    <Sider
      style={{ display: isDentalRecordScreen ? "none" : "block" }}
      theme="light"
      width={200}
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapse}
      className="side_bar"
      trigger={null} // This hides the default collapse trigger icon
    >
      {/* Top section: "Admin Panel" text with collapse icon */}
      <div className={`logoAndCollapse ${collapsed ? "collapsed" : ""}`}>
        {/* Collapse icon and text inside the same ection */}
        <Link to="/">
          <div className={`logo-section ${collapsed ? "collapsed" : ""}`}>
            <img src={collapsed ? collapsedlogo : logo} alt="logo" />
          </div>
        </Link>

        <div
          style={{
            cursor: "pointer",
          }}
          onClick={toggleCollapse}
        >
          {collapsed ? (
            <img src={collapsedOpen} />
          ) : (
            <img src={collapsedClose} />
          )}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          marginTop: 60,
          marginLeft: collapsed ? 20 : 0,
        }}
      >
        {!collapsed && (
          // <Link to={"/subscription"}>
          <p
            style={{
              fontSize: collapsed ? 14 : 16,
              color: "#20C3FF",
              fontFamily: "Poppins-Medium",
              textDecoration: "underLine",
            }}
          >
            {userdata?.organization?.name}
          </p>
          // </Link>
        )}
      </div>

      {/* Menu items */}
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["/dashboard"]}
        selectedKeys={[location.pathname]} // Dynamically set the selected key based on the URL
        items={menuItems}
        style={{ marginTop: 0 }} // Adjust margin to prevent overlap with the top section
      />
      <div
        className="side_menu_logout_section"
        onClick={handleLogout}
        style={{ marginLeft: collapsed ? 7 : 0, marginTop: 5 }}
      >
        <img src={logoutIcon} />
        {!collapsed && <p>Logout</p>}
      </div>
    </Sider>
  );
};

export default Sidebar;
